<ng-container *appRequirePermission="button.permission">
  @if (button.type === DataTableActionType.BUTTON && !isInvisible(button)) {
    <button
      (click)="callAction(button?.action, $event, rows)"
      class="icon-btn me-1 px-1 mb-1"
      triggers="hover"
      placement="top"
      [class.icon-btn-sm]="!isTablet()"
      [class.icon-btn-lg]="isTablet()"
      [class.dropdown-toggle]="button.children"
      [ngbTooltip]="button.name | translate"
      [disabled]="isDisabled(button)"
      [matMenuTriggerFor]="button.children ? submenu : null"
      [attr.data-cy]="(button.name | translate) + '-btn'"
    >
      @if (button.icon) {
        <i [class]="button.icon"></i>
      }
      @if (button.showName) {
        <span>{{ button.name | translate }}</span>
      }
    </button>
  }
  @if (button.type === DataTableActionType.MENUITEM && !isInvisible(button)) {
    <button
      mat-menu-item
      size="small"
      [disabled]="isDisabled(button)"
      [matMenuTriggerFor]="button.children ? submenu : null"
      [attr.data-cy]="(button.name | translate) + '-btn'"
      (click)="callAction(button?.action, $event, rows)"
    >
      @if (button.icon) {
        <i [class]="button.icon"></i>
      }
      {{ button.name | translate }}
    </button>
  }

  <mat-menu #submenu="matMenu">
    @for (child of button.children; track child) {
      <ng-container *appRequirePermission="child.permission">
        @if (child.children) {
          <app-data-table-nestable-actions
            [button]="child"
            [rows]="rows"
          ></app-data-table-nestable-actions>
        } @else {
          @if (!isInvisible(child)) {
            <button
              mat-menu-item
              size="small"
              [disabled]="isDisabled(child)"
              (click)="callAction(child?.action, $event, rows)"
            >
              @if (child.icon) {
                <i [class]="child.icon"></i>
              }
              {{ child.name | translate }}
            </button>
          }
        }
      </ng-container>
    }
  </mat-menu>
</ng-container>
